export default class Pagination {
  static items_per_page = 20;
  constructor(number_of_rows, items_per_page = 20) {
    this.container = document.querySelector(".pagination");
    this.items_per_page = items_per_page;
    this.total_pages = Math.ceil(number_of_rows / this.items_per_page);
    this.current_page = 1;
  }
  display_pagination = () => {
    let div = "";
    if (this.total_pages < 2) {
      this.container.innerHTML = div;
      return;
    }
    div += this.display_pagination_prev();
    div += this.dispaly_pagination_items();
    div += this.display_pagination_next();
    this.container.innerHTML = div;
  };

  display_pagination_prev = () => {
    if (this.current_page < 2) return "";
    return `<div class="pagination-item ${
      this.current_page - 1 > 0 ? "" : "disabled"
    }" data-id=${
      this.current_page - 1 > 0 ? this.current_page - 1 : 1
    }>Prev</div>`;
  };

  display_pagination_next = () => {
    if (this.current_page == this.total_pages) return "";
    return `<div class="pagination-item ${
      this.current_page + 1 > this.total_pages ? "disabled" : ""
    }" data-id=${
      this.current_page + 1 > this.total_pages
        ? this.total_pages
        : this.current_page + 1
    }>Next</div>`;
  };

  dispaly_pagination_items = () => {
    if (this.current_page < 5) {
      return this.display_pagination_start();
    } else if (this.current_page > this.total_pages - 4) {
      return this.display_pagination_end();
    } else {
      return this.display_pagination_middle();
    }
  };

  display_pagination_start = () => {
    let div = "";
    const limit = 5;
    const has_more_pages_than_limit = this.total_pages > limit;
    const end = has_more_pages_than_limit ? limit : this.total_pages;
    for (let page_number = 1; page_number <= end; page_number++) {
      div += `<div class="pagination-item ${
        this.current_page == page_number ? "active" : ""
      }" data-id=${page_number}>${page_number}</div>`;
    }
    if (has_more_pages_than_limit)
      div += `<div class="pagination-item disabled">...</div><div class="pagination-item" data-id=${this.total_pages}>${this.total_pages}</div>`;
    return div;
  };

  display_pagination_end = () => {
    let div =
      '<div class="pagination-item" data-id=1>1</div><div class="pagination-item disabled">...</div>';
    const start = this.total_pages - 4;
    for (
      let page_number = start;
      page_number <= this.total_pages;
      page_number++
    ) {
      div += `<div class="pagination-item ${
        this.current_page == page_number ? "active" : ""
      }" data-id=${page_number}>${page_number}</div>`;
    }
    return div;
  };

  display_pagination_middle = () => {
    let div =
      '<div class="pagination-item" data-id=1>1</div><div class="pagination-item disabled">...</div>';
    const start = this.current_page - 2;
    const end = this.current_page + 1;
    for (let page_number = start; page_number <= end; page_number++) {
      div += `<div class="pagination-item ${
        this.current_page == page_number ? "active" : ""
      }" data-id=${page_number}>${page_number}</div>`;
    }
    div += `<div class="pagination-item disabled">...</div><div class="pagination-item" data-id=${this.total_pages}>${this.total_pages}</div>`;
    return div;
  };

  change_page = (event) => {
    this.current_page = parseInt(event.target.getAttribute("data-id"));
    this.display_pagination();
  };
}
